/**
 * Returns the value of a Bootstrap breakpoint min-width for a given size.
 * @param {string} size - Breakpoint size
 * @returns {number} Breakpoint min-width
 */
const getBreakpoint = (size) =>
	parseFloat(
		getComputedStyle(document.body)
			.getPropertyValue(`--bs-breakpoint-${size}`)
	);

/**
 * Object of all Bootstrap breakpoint min-widths.
 *
 * **IMPORTANT**: If you're doing the equivalent of a `media-breakpoint-up` rule, make sure
 * you use a *"[num] is greater than **or equal** to [breakpoint]"* check. Conversely, for
 * `media-breakpoint-down`, make sure you use a *"[num] is less than **and not equal to**
 * [breakpoint]"* check.
 */
export const Breakpoint = {
	XS: getBreakpoint('xs'),
	SM: getBreakpoint('sm'),
	MD: getBreakpoint('md'),
	LG: getBreakpoint('lg'),
	XL: getBreakpoint('xl'),
	XXL: getBreakpoint('xxl')
};
